import { Section, Bullets, FeatureGrid, RelatedLinks, FinalCTA } from "@/components/v2/blocks";
import PageHeroPhoto from "@/components/v2/PageHeroPhoto";

export default function GestionMultiSites() {
  return (
    <div>
      <PageHeroPhoto
        cmsKey="multisites"
        eyebrow="Professionnels · Multi-sites"
        title="Gestion multi-sites : centralisez la vision de vos contrats d'énergie"
        subtitle="Lorsque plusieurs établissements, agences ou immeubles sont concernés, la gestion énergétique devient plus complexe. Energy Market accompagne les organisations multi-sites dans l'analyse et la centralisation de leurs contrats."
        image="/img/multi-sites.png"
        overlay="brand-light"
        flipLogo
        highlightsLabel="Une gestion centralisée"
        highlights={[
          "Une vision globale de votre portefeuille",
          "Un suivi proactif de chaque échéance",
          "Moins de dispersion, plus de clarté",
          "Des consultations facilitées",
        ]}
      />

      <Section cmsKey="multisites.publics" eyebrow="Publics concernés" title="Pour qui ?">
        <Bullets columns={2} items={[
          "Entreprises multi-sites",
          "Réseaux commerciaux",
          "Franchises",
          "Groupes d'entreprises",
          "Sites industriels",
          "Syndics de copropriété",
        ]} />
      </Section>

      <Section cmsKey="multisites.syndics" eyebrow="Focus syndics de copropriété" title="Des dizaines, voire des centaines de compteurs" intro="Chaque résidence possède ses échéances, ses fournisseurs, ses caractéristiques techniques et ses contraintes spécifiques. Energy Market accompagne les syndics dans la centralisation des informations et la préparation des futures consultations." muted />

      <Section cmsKey="multisites.benefices" eyebrow="Bénéfices" title="Les avantages d'une gestion centralisée">
        <FeatureGrid items={[
          { title: "Vision globale", text: "Une lecture d'ensemble de votre portefeuille énergétique." },
          { title: "Anticipation des échéances", text: "Un suivi proactif de chaque contrat." },
          { title: "Simplification administrative", text: "Moins de dispersion, plus de clarté." },
          { title: "Meilleure organisation", text: "Des informations centralisées et structurées." },
          { title: "Consultations facilitées", text: "Une préparation simplifiée des appels d'offres." },
        ]} />
      </Section>

      <Section title="Pour aller plus loin" muted>
        <RelatedLinks links={[
          { to: "/professionnels/optimisation-des-contrats", label: "Optimisation des contrats" },
          { to: "/professionnels/anticipation-des-contrats", label: "Anticipation des contrats" },
          { to: "/contact", label: "Contact" },
        ]} />
      </Section>

      <FinalCTA title="Centralisez la gestion de vos sites" text="Structures multi-sites et syndics : déposez vos factures et demandez une étude personnalisée." />
    </div>
  );
}
